import { IntegrationsContainerContent } from '@modules/integrationsV2/components/IntegrationsContainer/IntegrationsContainerContent';
import {
  useCreateOAuthIntegration,
  useFetchConnectedIntegrations,
} from '@modules/integrationsV2/hooks';
import { IntegrationsActionType } from '@modules/integrationsV2/store/integrationsActionType';
import { useIntegrationsStore } from '@modules/integrationsV2/store/integrationsStore';
import { useLocation } from 'react-router-dom';
import useGetIntegrationsFormData from 'v2/core/repository/edge-server/integrations/useGetIntegrationsFormData';
import useFullscreenLoader from 'v2/core/services/loader/useFullscreenLoader';

export const IntegrationsContainer = () => {
  const location = useLocation();

  const { connectedIntegrations, isLoading: isFetchingConnectedIntegrations } =
    useFetchConnectedIntegrations();

  const isAddIntegrationDrawerOpen = useIntegrationsStore(
    ({ view }) => view.isAddDrawerOpen,
  );
  const dispatch = useIntegrationsStore(({ dispatch }) => dispatch);

  const isCreatingIntegration = useCreateOAuthIntegration({
    redirectUri: location.pathname,
    onCompleted: (integrationID: string) => {
      dispatch({
        type: IntegrationsActionType.SET_VIEW,
        payload: {
          selectedIntegrationIDToUpdate: integrationID,
        },
      });

      if (isAddIntegrationDrawerOpen) {
        dispatch({
          type: IntegrationsActionType.SET_VIEW,
          payload: {
            isAddDrawerOpen: false,
          },
        });
      }
    },
  });

  useGetIntegrationsFormData({
    fetchPolicy: 'cache-and-network', // Fetch form data from network to update cache
  });

  const isLoading = isFetchingConnectedIntegrations || isCreatingIntegration;

  useFullscreenLoader({
    isLoading,
    isInvisible: true,
  });

  return !isLoading ? (
    <IntegrationsContainerContent integrations={connectedIntegrations} />
  ) : null;
};
